import _ from 'lodash';

import { mapActions, mapGetters, mapMutations } from 'vuex';
import { getProductPriceTitle, hasVisibleDiscount, resolveProductImage, routeToProduct } from '@/helpers';
import { MEDIA, pluralizate } from '@/helpers/variables';
import StarRating from 'vue-star-rating';

import IconHeart from '@/components/icons/IconHeart.vue';
import IconDelete from '@/components/icons/IconDelete.vue';
import TypeSelect from '@/components/custom/TypeSelect/index.vue';

export default {
  name: 'BlockProductCard',
  components: {
    IconDelete,
    IconHeart,
    TypeSelect,
    StarRating
  },
  props: {
    product: {
      type: Object,
      default: () => {}
    }
  },

  data() {
    return {
      MEDIA,
      selectedProductPrice: null,
      favoriteSelect: false
    };
  },
  created() {
    if (this.product.productPrices?.data.length) {
      let { data: productPrices } = this.product.productPrices;
      let sortedProductPrices = _.orderBy(productPrices, ['value'], ['asc']);
      let defaultPrice = sortedProductPrices[0];
      this.selectProductPrice(defaultPrice);
    }
  },
  watch: {
    selectedProductPrice: function () {
      this.selectProductPrice(this.selectedProductPrice);
    }
  },
  computed: {
    ...mapGetters({
      isAuthenticated: 'auth/isAuthenticated',
      favourites: 'favorites/whichList',
      appSize: 'app/size'
    }),
    isHasVisibleDiscount() {
      return hasVisibleDiscount(this.selectedProductPrice);
    },
    isComingSoon() {
      return this.product.isComingSoon;
    },
    commentsCount() {
      return this.product.feedbacks.data.length;
    },
    commentsPluralizate() {
      return pluralizate(
        this.commentsCount,
        this.$t('label.comments.countOne'),
        this.$t('label.comments.countSimple'),
        this.$t('label.comments.countMany')
      );
    },
    firstSentence() {
      let { description } = this.product;
      if (description) {
        let match = description.match(/[^.?!]*[.?!](?=\s|$)/);
        return match ? match[0].trim() : '';
      }
      return '';
    }
  },

  methods: {
    getProductPriceTitle,
    ...mapActions({
      addToFavorite: 'favorites/ADD_PRODUCT_TO_FAVOURITES',
      removeFromFavorite: 'favorites/REMOVE_PRODUCT_IN_FAVORITE',
      getFavorites: 'favorites/GET_FAVORITES_LIST'
    }),
    ...mapMutations({
      changeLoginPopup: 'popups/CHANGE_LOGIN_POPUP'
    }),

    routeToProduct: routeToProduct,
    resolveProductImage: resolveProductImage,
    /**
     * @param {ProductPrice} productPrice
     */
    selectProductPrice(productPrice) {
      this.selectedProductPrice = productPrice;
    },
    onChangeFavorite() {
      if (this.isAuthenticated) {
        const index = this.favourites.find((e) => e.productId === this.product.id);
        if (index) {
          this.removeFromFavorite(index.id).then(() => {
            this.getFavorites();
            this.favoriteSelect = false;
            this.$toasted.success(this.$t('toast.successRemoveFromFavorite'));
          });
        } else {
          this.addToFavorite({ product_id: this.product.id }).then(() => {
            this.favoriteSelect = true;
            this.$toasted.success(this.$t('toast.successAddToFavorites'));
            this.getFavorites();
          });
        }
      } else {
        this.changeLoginPopup(true);
      }
    }
  }
};
